import React from 'react';

import { DefaultLayout } from 'hellosign/common/layout';
import { AppShell } from 'hellospa/components/app-shell/app-shell';
import { useFeatureFlag } from 'js/sign-components/common/feature-flag';

type LayoutProps = React.PropsWithChildren<{}>;

function LegacyTemplateGalleryLayout({ children }: LayoutProps) {
  return <DefaultLayout>{children}</DefaultLayout>;
}

export function TemplateGalleryLayout({ children }: LayoutProps) {
  const useInternalAppShell = useFeatureFlag(
    'sign_core_2026_10_12_internal_app_shell',
  );

  if (!useInternalAppShell) {
    return (
      <LegacyTemplateGalleryLayout>{children}</LegacyTemplateGalleryLayout>
    );
  }

  return (
    <AppShell
      selectedNavigationItem="templateGallery"
      fallbackLayout={LegacyTemplateGalleryLayout}
    >
      {children}
    </AppShell>
  );
}
